import React, { useState, useEffect, useMemo } from 'react';
import { Button } from '@leverege/ui-elements';
import { Attributes, DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import { jsx as _jsx } from "react/jsx-runtime";
const EMPTY = {};
function VehicleLink(props) {
  const {
    object,
    cxt
  } = props;
  const {
    clientProps: {
      actions: saleActions
    }
  } = cxt;
  const vehicleId = Attributes.get('sale.vehicle.id', 'sale', object.data);
  const vehicleActions = useMemo(() => {
    let ref = saleActions.getInterfaceUrl();
    if (ref.indexOf('sales') > -1) {
      ref = ref.replace('sales', 'vehicles');
      ref = ref.endsWith('vehicles') ? ref : trimRef(ref);
    } else if (ref.indexOf('sale')) {
      ref = ref.replace('sale', 'vehicle');
      ref = ref.endsWith('vehicle') ? ref : trimRef(ref);
    }
    const objRef = {
      id: vehicleId,
      type: 'vehicle',
      ref
    };
    return DataSources.getActions(objRef);
  }, [saleActions, vehicleId]);
  const [dealershipHasVehicle, setDealershipHasVehicle] = useState(false);
  useEffect(() => {
    const getVehicle = async () => {
      try {
        const vehicle = await GlobalState.dispatch(vehicleActions.get());
        if (vehicle.id) {
          setDealershipHasVehicle(true);
        }
      } catch (ex) {
        console.error(ex, 'Dealership does not have vehicle');
        // dont care
      }
    };
    getVehicle();
  }, []);
  if (!dealershipHasVehicle) {
    return null;
  }
  const goToVehicle = () => {
    // assume we're at a single vehicle, but not at the root vehicles list
    GlobalState.dispatch(vehicleActions.parent().goTo(vehicleId));
  };
  return /*#__PURE__*/_jsx(Button, {
    variant: "detailSecondary",
    onClick: goToVehicle,
    disabled: !vehicleId,
    children: "Go To Vehicle"
  });
}
export default class SaleVehicleLinkRenderer {
  getValueComponent(object, cxt) {
    return /*#__PURE__*/_jsx(VehicleLink, {
      object: object,
      cxt: cxt
    });
  }
  getComponents(object, cxt = EMPTY) {
    return [{
      style: {},
      component: this.getValueComponent(object, cxt)
    }];
  }
}
function trimRef(ref) {
  const arr = ref.split('/');
  arr.pop();
  return arr.join('/');
}